// extracted by mini-css-extract-plugin
export var actionButton = "_ir-0";
export var fileInput = "_ir-2";
export var paperclip = "_ir-1";